"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCREENSHARE = exports.PRESENTER = exports.PENDING = exports.MICROPHONE = exports.MAX_RETRIES = exports.DIRECTOR_KNOCK_TYPES = exports.DENIED = exports.CAMERA = exports.ACCEPTED = void 0;
// KnockTypes
var MICROPHONE = exports.MICROPHONE = 'microphone';
var PRESENTER = exports.PRESENTER = 'presenter';
var SCREENSHARE = exports.SCREENSHARE = 'screenshare';
var CAMERA = exports.CAMERA = 'camera';
var DIRECTOR_KNOCK_TYPES = exports.DIRECTOR_KNOCK_TYPES = [MICROPHONE, SCREENSHARE, CAMERA];

// KnockStatus
var ACCEPTED = exports.ACCEPTED = 'accepted';
var DENIED = exports.DENIED = 'denied';
var PENDING = exports.PENDING = 'pending';

// Max Knock create attendee API call retries
var MAX_RETRIES = exports.MAX_RETRIES = 2;